import {getCookie} from "./siteInit";

const SUPPORTED = ['en', 'pl', 'de', 'fr', 'es', 'it', 'tr', 'hu', 'ro', 'cs', 'sk'];
const DEFAULT_LANG = 'en';
// Only the explicit-choice cookie may trigger a redirect. `i18next` is left alone: it is
// shared with the admin app and legacy copies record a page the visitor merely landed on.
const COOKIE_NAME = 'chatlab_lang';

const normalize = (value) => {
    if (!value) return null;
    const code = String(value).toLowerCase().trim().split('-')[0];
    return SUPPORTED.includes(code) ? code : null;
};

const getCurrentLang = (pathname) => {
    for (const lang of SUPPORTED) {
        if (lang === DEFAULT_LANG) continue;
        if (pathname === `/${lang}` || pathname.startsWith(`/${lang}/`)) {
            return lang;
        }
    }
    return DEFAULT_LANG;
};

const getBasePath = (pathname, currentLang) => {
    if (currentLang === DEFAULT_LANG) return pathname;
    const rest = pathname.slice(`/${currentLang}`.length);
    return rest === '' ? '/' : rest;
};

const buildPath = (basePath, targetLang) => {
    if (targetLang === DEFAULT_LANG) return basePath;
    return basePath === '/' ? `/${targetLang}/` : `/${targetLang}${basePath}`;
};

// An explicit pick in the language switcher is the ONLY redirect trigger. Never fall back to
// navigator.language: Googlebot renders with en-US and no cookies, so a navigator-based
// redirect made every non-EN page a "Page with redirect" in Search Console (deindexed).
// Never fall back to the shared `i18next` cookie either - it is written for the admin app
// and, before 2026-09, was written on every page view, so it does not mean "chosen".
const detectDesiredLang = () => normalize(getCookie(COOKIE_NAME));

export const detectAndRedirectLanguage = () => {
    if (typeof window === 'undefined') return false;
    const {pathname, search, hash} = window.location;
    const desiredLang = detectDesiredLang();
    if (!desiredLang) return false;
    const currentLang = getCurrentLang(pathname);
    if (desiredLang === currentLang) return false;
    const targetPath = buildPath(getBasePath(pathname, currentLang), desiredLang);
    window.location.replace(targetPath + search + hash);
    return true;
};
